import React from 'react';
import { Building2, LayoutTemplate, ScrollText } from 'lucide-react';
import { SUPPORT_TAB } from '../support/ProductSupportTab';

// THE PIPELINES TAB BAR — Hotels | Pipeline Templates | Logs — shared by the Pipelines page and the pages opened from
// it (one hotel's pipeline), so the bar the user clicked from is still there, with the tab they came from lit.
// Logs are superadmin-only on the server, so the tab is offered only where it can load. Support lists the Pipelines
// tickets of the hotel / chain in the navbar (a hotel's own pipeline has its own Support subtab).
export const pipelinesTabs = (isSuperAdmin) => [
    { key: 'hotels', label: 'Hotels', icon: <Building2 size={20} /> },
    { key: 'integrations', label: 'Pipeline Templates', icon: <LayoutTemplate size={20} /> },
    { key: 'logs', label: 'Logs', icon: <ScrollText size={20} />, hidden: !isSuperAdmin },
    SUPPORT_TAB,
];

// The tab lives in the URL (?tab=templates|logs|support; Hotels is the bare /pipelines), so a link opens on its tab and Back
// returns to the tab it left.
export const pipelinesTabSearch = (key) =>
    key === 'logs' ? { tab: 'logs' } : key === 'integrations' ? { tab: 'templates' } : key === 'support' ? { tab: 'support' } : {};

export const pipelinesTabFromSearch = (requested, isSuperAdmin) =>
    requested === 'logs' && isSuperAdmin ? 'logs' : requested === 'templates' ? 'integrations'
        : requested === 'support' ? 'support' : 'hotels';

export const pipelinesTabPath = (key) => {
    const search = new URLSearchParams(pipelinesTabSearch(key)).toString();
    return `/pipelines${search ? `?${search}` : ''}`;
};
